export default __webpack_public_path__ + "img/9ca3d3c3ca931d638f11f44072a15774.png";